import { render, staticRenderFns } from "./Redactor.vue?vue&type=template&id=592d7459&"
import script from "./Redactor.vue?vue&type=script&lang=js&"
export * from "./Redactor.vue?vue&type=script&lang=js&"
import style0 from "./Redactor.vue?vue&type=style&index=0&id=592d7459&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports